var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeedTest = function SvgIconSpeedTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.485 48c-13.233 0-24-10.766-24-24s10.767-24 24-24c3.894 0 7.76.954 11.183 2.76a2.006 2.006 0 1 1-1.873 3.549 20 20 0 0 0-9.31-2.297c-11.021 0-19.986 8.966-19.986 19.986s8.966 19.986 19.986 19.986c11.019 0 19.986-8.967 19.986-19.986 0-2.218-.36-4.396-1.072-6.474a2.007 2.007 0 0 1 3.797-1.3 24 24 0 0 1 1.288 7.774c0 13.233-10.766 23.999-24 23.999z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.789 15.947a1.658 1.658 0 0 1 2.082 2.406l-5.67 10.32a6.105 6.105 0 1 1-7.44-8.596l11.026-4.132z"
  })));
};
export default SvgIconSpeedTest;